<template>
  <div>
      <fields :checkout="checkout"/>
  </div>
</template>

<script>
import fields from './fields.vue';
export default {
    name: 'individual',
    components:{
        fields
    },
    props:{
        checkout: Object
    }
}
</script>

<style>

</style>